export const habaCatalogForm = {
  habaCatalogForm: {
    heading: 'Request for free',
    personalData: 'What are your personal details?',
    form: {
      title: {
        label: 'Title*',
        error: 'Please select title',
      },
      firstName: {
        label: 'First name*',
        error: 'Please enter first name',
      },
      lastName: {
        label: 'Last name*',
        error: 'Please enter last name',
      },
      address1: {
        label: 'Street*',
        error: 'Please enter street',
      },
      nr: {
        label: 'No.*',
        error: 'Please enter number',
      },
      birthdate: {
        label: 'Date of birth*',
        error: 'Please enter date of birth',
      },
      country: {
        label: 'Country*',
        error: 'Please select country',
      },
      city: {
        label: 'City*',
        error: 'Please enter city',
      },
      zipCode: {
        label: 'Postal code*',
        error: 'Please enter postal code',
      },
      email: {
        label: 'Email address*',
        error: 'Please enter email address',
      },
      submit: 'Request',
    },
  },
};
